module.exports = __webpack_public_path__ + "img/wallet-earnings-empty.273382b2.svg";